<template>
  <main class="imprint" v-if="about">
    <section class="col-2">
      <div v-html="about.imprint"></div>
      <div></div>
    </section>
  </main>
</template>

<script>
export default {
  name: "imprint",
  metaInfo: {
    title: "– Imprint"
  },
  computed: {
    about() {
      return this.$store.state.about;
    }
  }
};
</script>

<style lang="scss">
.imprint {
  p {
    margin-bottom: var(--lh);
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
